/**
 * Searches loyalty-reward-eligible items as the
 * merchant types. Hits the admin item search endpoint
 * and replaces the results turbo frame on every
 * keystroke (debounced).
 */
import { Controller } from "@hotwired/stimulus";
import debounce from "lodash/debounce";
import { get } from "@rails/request.js";
import * as Sentry from "@sentry/browser";
import ToastService from "../../shared/toast_service";

export default class extends Controller {
  static targets = ["input", "loading"];
  static values = {
    url: String,
    rewardTypeSelector: String,
    venueIdSelector: String,
    selectedSelector: String,
    errorMessage: {
      type: String,
      default: "Search failed. Please try again.",
    },
  };

  connect() {
    this.search = debounce(this._run.bind(this), 250);
  }

  onInput() {
    this.search();
  }

  refresh() {
    this._run();
  }

  _run() {
    const params = new URLSearchParams();
    params.set(
      "query",
      this.hasInputTarget ? this.inputTarget.value : ""
    );
    params.set("reward_type", this._rewardType());
    const venueId = this._venueId();
    if (venueId) params.set("venue_id", venueId);
    const selected = this._selectedId();
    if (selected) params.set("selected_id", selected);

    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove("hidden");
    }

    get(`${this.urlValue}?${params.toString()}`, {
      responseKind: "turbo-stream",
    })
      .then((response) => {
        if (this.hasLoadingTarget) {
          this.loadingTarget.classList.add("hidden");
        }
        if (!response.ok) {
          this._toastError();
        }
      })
      .catch((error) => {
        if (this.hasLoadingTarget) {
          this.loadingTarget.classList.add("hidden");
        }
        this._toastError();
        Sentry.captureException(error);
      });
  }

  _toastError() {
    new ToastService().toast({
      text: this.errorMessageValue,
      type: "error",
    });
  }

  _rewardType() {
    if (!this.hasRewardTypeSelectorValue) return "";
    const el = document.querySelector(
      this.rewardTypeSelectorValue
    );
    return el ? el.value : "";
  }

  _venueId() {
    if (!this.hasVenueIdSelectorValue) return "";
    const el = document.querySelector(
      this.venueIdSelectorValue
    );
    return el ? el.value : "";
  }

  _selectedId() {
    if (!this.hasSelectedSelectorValue) return "";
    const el = document.querySelector(
      this.selectedSelectorValue
    );
    return el ? el.value : "";
  }
}
